__turbopack_context__.v({
  "breadcrumbs": "bread-crumbs-module-scss-module__RqDIMa__breadcrumbs",
  "item": "bread-crumbs-module-scss-module__RqDIMa__item",
  "link": "bread-crumbs-module-scss-module__RqDIMa__link",
  "list": "bread-crumbs-module-scss-module__RqDIMa__list",
  "separator": "bread-crumbs-module-scss-module__RqDIMa__separator",
});
